export default __webpack_public_path__ + "static/media/cheetoshot-image.680c08fe.png";